import { initSingleModule } from "../functions.js";

export default function MenuModule(element) {

    let timeline;
    let animationController;
    let isVisible = false;

    let $menu          = element;
    let $bg            = element.querySelector('.menu__bg');
    let $logo          = element.querySelector('.menu__logo');
    let $items         = element.querySelectorAll('.menu__item');
    let $detail        = element.querySelector('.menu__detail');
    let $anim          = element.querySelector('.menu__anim');
    let $burger        = document.querySelector('.burger');

    function createTimeline() {
        timeline = gsap.timeline({
            onStart: function() {
                $menu.style.display = 'flex';
                $burger.classList.add('burger--active');
            },
            onComplete: function() {
                showAnimation();
            },
            onReverseComplete: function() {
                $burger.classList.remove('burger--active');
                $menu.style.display = 'none';
            }
        });

        timeline.from($bg,     { height: '0%', duration: 0.5});

        timeline.from($logo,   { opacity: 0, duration: 0.2});
        
        $items.forEach(async ($item, index) => {
            timeline.from($item, { y: 150, duration: 0.3}, '<0.1');
        });

        timeline.from($detail, { opacity: 0, scale: 0.1, ease:'back.out(5)', duration: 0.5});

        timeline.pause();
    }

    function show() {
        timeline.timeScale(1).play();
        $burger.classList.add('burger--moved');
        document.body.style.overflow = 'hidden';
        isVisible = true;
    }

    function hide() {
        if (animationController) {
            animationController.destroy();
            animationController = null;
        }
        $burger.classList.remove('burger--moved');
        timeline.timeScale(1.5).reverse();
        document.body.style.overflow = '';
        isVisible = false;
    }

    function showAnimation() {
        $anim.setAttribute('data-init-without-scrolltrigger', true);
        animationController = initSingleModule($anim, 'TerrainAnimationModule');
    }

    function bindEvents() {
        $burger.addEventListener('click', function() {
            if (isVisible) {
                hide();
            } else {
                show();
            }

            window.modules['MainModule'].playSound();
        });
    }

    function init() {
        createTimeline();
        bindEvents();
    }

    init();

    return this;

}
